var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fs-adjustments"},[_c('fs-range-filter-wrapper',{attrs:{"min":"0","max":"1","routerLink":'/adjustments',"label":"menu.blur"},model:{value:(_vm.value.blur),callback:function ($$v) {_vm.$set(_vm.value, "blur", $$v)},expression:"value.blur"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }